export default __webpack_public_path__ + "static/media/d3a766e3422a66c61776c6caa5b69916.svg";